import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  AccountUser,
  CreateAccountUserRequest,
  UpdateAccountUserRequest,
} from "../models/AccountUser";

export const AccountUserApi = {
  create: async (body: CreateAccountUserRequest) => {
    return await jwtAuthAxios().post<AccountUser>(`/account-users`, body);
  },

  update: async (accountUserId: string, body: UpdateAccountUserRequest) => {
    return await jwtAuthAxios().put<AccountUser>(
      `/account-users/${accountUserId}`,
      body
    );
  },

  delete: async (accountUserId: string) => {
    return await jwtAuthAxios().delete(`/account-users/${accountUserId}`);
  },
};
